import { useEffect, useRef, useState, useLayoutEffect, useCallback } from "react"
import styled from "@emotion/styled"
import useSSR from "hooks/useSSR"
import { useLocation } from "react-router-dom"
import VariationsCard from "./variations-card/VariationsCard"
import Loader from "components/loader/Loader"
import { buttonInline, buttonFilled, green, opaqueGreen, buttonReset } from "css/buttons"
import { Icon } from "components/icon/Icon"
import getMediaQuery from "css/breakpoints"
import { useDictionary } from "contexts/Dictionary"
import { GroupedVariationsProvider, useWatchgrid, writeSS } from "./context"
import { useHeader } from "contexts/Header"
import { gridTemplate } from "./../watch-grid/gridTemplate"
import { headline50, legend100, bold } from "css/text"
import { mapSolrResults } from "./../model/model-variations/catalog"
import { mvSubscribe } from "./../model/model-variations/context"
import QuickFilters from "./../watch-grid/QuickFilters"
import { getCurrentUrl } from "./utils"
//import { FLAGSHIPS } from "./FLAGSHIPS"
import { useLocale } from "contexts/Locale"
import { allParams } from "components/watch-grid/utils"
import { flushSync } from "react-dom"
import { useEnv } from "contexts/Env"

const Main = styled.section`
  position: relative;
`

const Container = styled.div`
  position: relative;
`

const Wrapper = styled.div`
  display: grid;
  justify-content: center;
  grid-template-areas: "grid sidebar";
  padding-block-end: 80px;

  ${getMediaQuery("xl")} {
    width: calc(100vw - (2 * var(--outer-margin)));
    margin-inline: auto;
    overflow: hidden;

    .panel-open & {
      justify-content: end;
      overflow: visible;
      grid-template-columns: 2fr 1fr;
    }
  }
`
const GridContent = styled.div`
  grid-area: grid;
  width: min(1920px, var(--watches-grid-width));
`

const NoResult = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  & > * {
    width: 100%;

    ${getMediaQuery("m")} {
      width: 70%;
    }
  }

  span {
    ${headline50}
    color: rgb(var(--green));
    margin-block-end: 20px;
  }

  p {
    ${legend100}
  }
`

const List = styled.ul`
  display: grid;
  gap: 8px;
  grid-template-columns: 1fr;
  grid-auto-rows: 1fr;
  margin-block-end: 10px;
  transition-property: opacity;
  transition-duration: 0.5s;
  grid-auto-rows: auto;

  &.visible,
  .no-js & {
    opacity: 1;
  }

  &:last-of-type {
    margin-block-end: 0;
  }

  ${getMediaQuery("l")} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${getMediaQuery("xxxl")} {
    grid-template-columns: repeat(2, 1fr);
  }
`

const CTAWrapper = styled.div`
  position: sticky;
  top: 80vh;
  z-index: 5;
  display: flex;
  width: 100%;
  pointer-events: none;
  flex-direction: row;
  justify-content: center;
  grid-gap: 1rem;

  ${getMediaQuery("xl")} {
    top: 90vh;
  }
`

const ResetButton = styled.button`
  ${buttonFilled}
  ${opaqueGreen}
  position: sticky;
  top: 80vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;
  visibility: hidden;

  [dir="rtl"] & {
    left: auto;
    right: 50%;
    transform: translateX(50%);
  }

  ${getMediaQuery("xl")} {
    top: 90vh;
  }
`

const ApplyButton = styled.button`
  ${buttonFilled}
  ${opaqueGreen}
  position: sticky;
  top: 80vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: 5;

  [dir="rtl"] & {
    left: auto;
    right: 50%;
    transform: translateX(50%);
  }

  ${getMediaQuery("xl")} {
    top: 90vh;
  }

  &.hidden {
    visibility: hidden;
  }
`

const FilterButton = styled.button`
  ${buttonReset}
  font-size: 16px;
  line-height: 80px;
  ${bold}
  user-select: none;
  transition: color 0.3s;
  overflow: hidden;

  &:hover {
    &:not(:disabled) {
      cursor: pointer;
      color: rgb(var(--green));
    }
  }

  &:disabled {
    color: rgb(var(--grey));
  }
`

const LoaderWrapper = styled.div`
  position: absolute;
  left: 0;
  width: 100%;
  margin-block-start: 20px;

  .loader {
    margin-inline: auto;
  }
`
const ButtonWrapper = styled.div`
  position: absolute;
  bottom: 110px;
  left: 0;
  width: var(--watches-grid-width);
  height: 80px;
  margin-inline: var(--outer-margin);
  border-block-end: 1px solid rgb(var(--light-grey));
  display: grid;
  justify-items: center;
`
const LoadButton = styled.button`
  ${buttonInline}
  ${green}
`

function CardList({ data, getModel, gridIndex, pricelist }) {
  const { selected } = useWatchgrid()
  const listRef = useRef()
  const gridTemplateCurrent = gridTemplate[18]

  function onSelection(v) {
    listRef.current.classList[v ? "add" : "remove"]("gv-selected")
  }
  useLayoutEffect(() => mvSubscribe("ModelVariations selected", selected, onSelection, false), [])

  return (
    <List ref={listRef}>
      {gridTemplateCurrent.map((item, i) => {
        const d = data[i]
        return d ? <VariationsCard key={d.cardid} {...d} index={`${gridIndex + i}`} getModel={getModel} pricelist={pricelist} /> : null
      })}
    </List>
  )
}
/*
function ButtonApply() {
  const { wapply, enableApply } = useWatchgrid()
  const ref = useRef()

  function onClick(e) {
    //    console.log("bbb ButtonApply onClick")
    wapply()
  }

  function onEnableApply(state) {
    //    console.log("bbb ButtonApply onEnableApply", state)
    const { current: el } = ref
    el.classList[state ? "remove" : "add"]("hidden")
  }

  useLayoutEffect(() => mvSubscribe("Watchgrid enableApply", enableApply, onEnableApply), [])

  return (
    <ApplyButton ref={ref} onClick={onClick} className="">
      <Icon type='filters' />
      {"Apply changes to all"}
    </ApplyButton>
  )
}

function ButtonReset() {
  const { enableReset, weaving, flagships, fromui } = useWatchgrid()
  const ref = useRef()

  function onClick(e) {
    console.log("bbb ButtonReset onClick")
    fromui.set(true)
    weaving.set(`*,${flagships.join(",")}`)
  }

  function onEnableReset(state) {
    ref.current.style.visibility = state ? "visible" : "hidden"
  }

  useLayoutEffect(() => mvSubscribe("Watchgrid enableReset", enableReset, onEnableReset), [])

  return (
    <ResetButton ref={ref} onClick={onClick}>
      {"Reset grid to default"}
    </ResetButton>
  )
}
*/

function GridResults({ flagships, results, pricelist }) {
  const currentUrl = getCurrentUrl()
  const usrkey = currentUrl?.searchParams?.get("usr")
  //  const flagships = FLAGSHIPS.get(grid || "all")
  const withVariations = flagships
    .filter(v => v.variations)
    .reduce((a, v) => {
      a.set(v.cardid, v.variations)
      return a
    }, new Map())

  results = results.map(v =>
    Object.assign(v, {
      variations: withVariations.get(v.cardid) ?? v.variations,
    })
  )

  return (
    <GroupedVariationsProvider flagships={flagships} catalog={results} usrkey={usrkey}>
      <GridResultsContent results={results} flagships={flagships} pricelist={pricelist} />
    </GroupedVariationsProvider>
  )
}

function GridResultsContent({ results, pricelist }) {
  const { flagships, weaving, getModel } = useWatchgrid()
  const [gridList, setGridList] = useState([])
  const gridWatchesNumberRef = useRef(18)
  const watchesCount = useRef(0)

  function filterFlagships() {
    return flagships.map(v => getModel(v.rmc)).filter(v => v.uid)
  }

  function getUserFlagships() {
    const remain = filterFlagships()
    watchesCount.current = remain.length

    const list = weaving.get() ?? remain.map(({ uid }) => uid).join(",")
    const target = list
      .split(",")
      .map(getModel)
      .filter(v => v.uid)

    return remain.map(item => {
      const match = target.find(v => v.cardid === item.cardid)
      return Object.assign({}, match ?? item)
    })
  }

  useEffect(() => {
    //    console.log("bbb GroupedVariations results", results)
    if (!results?.length) return
    generateContent(getUserFlagships())
  }, [results])

  function generateContent(list) {
    //    console.log("bbb GroupedVariations generateContent", list)
    const gridNumber = Math.ceil(watchesCount.current / gridWatchesNumberRef.current)
    const content = []

    for (let i = 0; i < gridNumber; i++) {
      let start = gridWatchesNumberRef.current * i
      let defaultEnd = start + gridWatchesNumberRef.current
      let end = defaultEnd > watchesCount.current ? start + (watchesCount.current - start) : defaultEnd
      content.push(
        <CardList key={`gvsplit_${i}`} data={list.slice(start, end)} getModel={getModel} gridIndex={i * gridWatchesNumberRef.current} pricelist={pricelist} />
      )
    }
    setGridList(content)
  }

  function updateUserQuery(hid) {
    const currentSearchParams = new URLSearchParams(window.location.search)
    const oldQuery = currentSearchParams.get("usr") ?? ""
    if (hid === oldQuery) return

    if (hid) {
      currentSearchParams.set("usr", hid)
    } else {
      currentSearchParams.delete("usr")
    }
    const newUrl = [window.location.pathname, currentSearchParams.toString()].filter(Boolean).join("?")
    // alright, let's talk about this...
    // Normally with remix, you'd update the params via useSearchParams from react-router-dom
    // and updating the search params will trigger the search to update for you.
    // However, it also triggers a navigation to the new url, which will trigger
    // the loader to run which we do not want because all our data is already
    // on the client and we're just doing client-side filtering of data we
    // already have. So we manually call `window.history.pushState` to avoid
    // the router from triggering the loader.
    window.history.pushState(null, "", newUrl)
  }

  function onWeaving(v) {
    //    console.log("traaack onWeaving", getCurrentUrl())
    if (!v) return
    const hid = `${new Date().getTime()}`
    //    const params = getCurrentUrl().searchParams
    //    params.set("usr", hid)
    if (writeSS(hid, v)) {
      updateUserQuery(hid)
      //      console.log("stamped", v)
      //      history.push(`?${params.toString()}`, { shallow: true })
      //      history.replaceState(history.state, "", `?${params.toString()}`)
    }
  }
  useLayoutEffect(() => mvSubscribe("ModelVariations weaving", weaving, onWeaving, false), [])

  return gridList
}

export default function GroupedVariations({ quick_filters, groups, grid, disable_grouped_view_quick_filters, fullgridURL }) {
  //console.log("GroupedVariationsGroupedVariations", fullgridURL)
  const [results, setResults] = useState([])
  //  const [collection, setCollection] = useState(null)

  const header = useHeader()
  const mainRef = useRef()
  const [loaderDisplay, setLoaderDisplay] = useState(false)
  const location = useLocation()
  const [fadeIn, setFadeIn] = useState(true)
  const locale = useLocale()
  const env = useEnv()
  const [pricelist, setPricelist] = useState(null)

  const watchgridURL = new URL(
    `/api/catalog/groupedgrid/variations?language=${locale.current.codes.www}&grid=${grid}`,
    process.browser ? env.services : process.env.SERVICE_CATALOG_URL
  )
  const params = new URLSearchParams(location.search)
  let applytoall = false
  if (params.toString()) {
    params.forEach((value, key) => {
      applytoall = applytoall || key === "all"
      if (allParams.includes(key)) {
        const allValues = params.getAll(key)

        if (allValues.length === 1) watchgridURL.searchParams.set(key, value)
        else watchgridURL.searchParams.set(key, `(${allValues.toString()})`)
      }
    })
  }

  async function loadContent(controller) {
    setLoaderDisplay(true)
    const response = await fetch(watchgridURL, {
      signal: controller.signal,
    })
    const jsonData = await response.json()
    let cleaned = jsonData.results.map(mapSolrResults)
    const _fullgridURL = fullgridURL
    _fullgridURL.searchParams.delete("numberOfResults")
    const fullresponse = await fetch(_fullgridURL, {
      signal: controller.signal,
    })
    const fulljsonData = await fullresponse.json()
    const priceList = fulljsonData.results.reduce((a, v) => {
      a.set(v.rmc, v.formattedPrice)
      return a
    }, new Map())
    priceList.set("pricePopin", fulljsonData.pricePopin)
    //    console.log("bbb GroupedVariations loadContent cleaned", cleaned)
    setResults(cleaned)
    setPricelist(priceList)
    setLoaderDisplay(false)
    setFadeIn(true)
  }

  useEffect(() => {
    setFadeIn(false)
    const controller = new AbortController()

    const handler = setTimeout(() => {
      loadContent(controller)

      if (global?.scrollY !== 0) {
        header.freeze("watchgrid")

        const headerHeight = header.expansion()
          ? document.querySelector("header").clientHeight
          : 0 + document.querySelector(".header-subnav")
          ? document.querySelector(".header-subnav").clientHeight
          : 0
        const top = mainRef.current.offsetTop - headerHeight
        global?.scrollTo(0, top)

        global?.requestAnimationFrame(() => {
          header.unfreeze("watchgrid")
        })
      }
    }, 0)

    return () => {
      clearTimeout(handler)
      controller.abort()
    }
  }, [location])

  return (
    <Main ref={mainRef} className={applytoall ? "wv_applytoall" : ""}>
      {quick_filters?.length > 0 ? (
        <QuickFilters quickFilters={quick_filters} searchUids={[] /*searchUids*/} disable={disable_grouped_view_quick_filters} />
      ) : null}

      <Container>
        <Wrapper>
          <GridContent>
            {!loaderDisplay && <GridResults results={results} flagships={groups} pricelist={pricelist} />}

            {loaderDisplay && (
              <LoaderWrapper>
                <Loader />
              </LoaderWrapper>
            )}
          </GridContent>
        </Wrapper>
      </Container>
    </Main>
  )
}
